import { render, staticRenderFns } from "./pwdLogin.vue?vue&type=template&id=49c7664f&scoped=true"
import script from "./pwdLogin.vue?vue&type=script&lang=ts"
export * from "./pwdLogin.vue?vue&type=script&lang=ts"
import style0 from "./pwdLogin.vue?vue&type=style&index=0&id=49c7664f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7664f",
  null
  
)

export default component.exports